/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CheckGreen(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CheckGreen',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 18 * scale,
      viewBox: '0 0 18 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('path', {"d":"M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0","fill":"#27D86E","fillRule":"nonzero"}),createElement('path', {"fill":"#FFF","d":"M8.065 13.46 3.968 9.466l1.396-1.432 2.57 2.506 4.556-5.315 1.518 1.302z"})))
}
